import useLocale from './useLocale';

interface UseCurrencyInputOptions {
  max?: number;
  showDecimals?: boolean;
  clipMaxValue?: boolean;
}

const useCurrencyInput = ({
  max = 2 ** 31 - 1,
  showDecimals = true,
  clipMaxValue = true,
}: UseCurrencyInputOptions = {}) => {
  const { formatNumber, parseCurrency, thousandsSeparator, decimalSeparator } = useLocale();

  const formatProps = {
    useGrouping: false,
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  };

  const value = (parsedValue: number | null) => {
    if (parsedValue != null) {
      return formatNumber(parsedValue / 100, formatProps);
    }

    return '';
  };

  const parse = (value: string) => {
    if (value) {
      let parsedValue = parseCurrency(value);

      if (!showDecimals) {
        parsedValue = Math.round(parsedValue / 100) * 100;
      }

      if (!Number.isNaN(parsedValue)) {
        parsedValue = clipMaxValue ? Math.min(parsedValue, max) : parsedValue;
        return parsedValue;
      }
    }

    return null;
  };

  const format = (value: string) => {
    if (value) {
      let parsedValue = parseCurrency(value);

      if (!Number.isNaN(parsedValue)) {
        parsedValue = clipMaxValue ? Math.min(parsedValue, max) : parsedValue;
        return formatNumber(parsedValue / 100, formatProps);
      }
    }

    return '';
  };

  const match = new RegExp(`[0-9${thousandsSeparator}${decimalSeparator}]`, 'g');

  return {
    value,
    parse,
    format,
    match,
  };
};

export default useCurrencyInput;
